import clsx from 'clsx'
import React, {useContext} from 'react'
import ClearableSelect from 'components/clearable-select'
import MenuItem from '@mui/material/MenuItem'

import {orderBy} from 'external/lodash'

import { selectCourseLabel } from 'helpers/quiz'


import {TeacherContext} from 'teacher/context'

export default function CourseFilter (props) {

  const {classes, onChange} = props
  const context = useContext(TeacherContext)
  const {myCourses, query, translate} = context
  const courses = query.subject
    ? myCourses.filter(({course}) => course.substring(0,2) == query.subject)
    : myCourses

  return (
    <ClearableSelect
      id="question-bank-course-filter"
      className={clsx(classes.select, "course")}
      value={query.course || ""}
      onChange={onChange}
      caption={translate('course_assessment_header')}
    >
      {orderBy(courses, ['course']).map((course, key) => {
        return (<MenuItem value={course.course} key={key}>{selectCourseLabel(course)}</MenuItem>)
      })}
    </ClearableSelect>
  )
}

